import { createRouter, createWebHistory } from 'vue-router';
// import Locations from '../views/Locations.vue';
// import AddEnergySite from '../views/AddEnergySite.vue';
// import EditEnergySite from '../views/EditEnergySite.vue';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import Profile from '../views/Profile.vue';
import SetPassword from '../views/SetPassword.vue';
// import Companies from '../views/Companies.vue';
// import PaymentTypes from '../views/PaymentTypes.vue';
import Dashboard from '../views/Dashboard.vue';
// import Documents from '../views/Documents.vue';
import AnalysisReview from '../views/AnalysisReview.vue';
import HomeVisitReview from '../views/HomeVisitReview.vue';
import AllAnalysisReview from '../views/AllAnalysisReview.vue';
import AllHomeVisitReview from '../views/AllHomeVisitsReview.vue';
import NewAnalysis from '../views/NewAnalysis.vue';
import NewHomeVisit from '../views/NewHomeVisit.vue';
import ForgotPassword from '../views/ForgotPassword.vue';
import Pay from '../views/Pay.vue';
import PaySuccess from '../views/PaySuccess.vue';
import store from "@/store";


debugger;
const authGuard = (to, from, next) => {
  debugger;
  // console.log('ROUTER authGuard###################################');
  if (store.getters.isAuthenticated) {
    // console.log('ROUTER isAuthenticated');
    next();
  } else {
    // console.log('ROUTER Login');
    store.dispatch("logout")
    //router.push({ name: 'Login' })
    localStorage.setItem('redirectUrl', to.path)
    next({ name: 'Login' })
  }
};

/*
const getTranslate = (key) => {
  //// console.log('ROUTER ################################### GetTranslate: ' + key);
  //// console.log(store);
  //store.getters.getTranslate(key)
} 
*/

const routes = [
  // {
  //   path: '/OldNekajRoot',
  //   name: 'home',
  //   component: Locations,
  //   beforeEnter: authGuard 
  // }, 
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard, 
    beforeEnter: authGuard,
    props: true
  },   
  // {
  //   path: '/locations',
  //   name: 'Energy sites',
  //   component: Locations,
  //   beforeEnter: authGuard,
  //   props: true
  // },   
  // {
  //   path: '/addEnergySite',
  //   name: 'AddEnergySite',
  //   component: AddEnergySite,
  //   beforeEnter: authGuard
  // },
  // {
  //   path: '/EditEnergySite/:id',
  //   name: 'EditEnergySite',
  //   component: EditEnergySite,
  //   beforeEnter: authGuard,
  //   props: true
  // },  
  {
    path: '/login',
    name: 'Login',
    component: Login
  }, 
  {
    path: '/register',
    name: 'Register',
    component: Register
  },  
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },    
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    beforeEnter: authGuard,
  },
  {
    path: '/analysisreview/:id',
    name: 'AnalysisReview',
    component: AnalysisReview,    
    beforeEnter: authGuard,
    props: true,
  },
  {
    path: '/allanalysisreview',
    name: 'AllAnalysisReview',
    component: AllAnalysisReview,
    beforeEnter: authGuard 
  },
  {
    path: '/homevisitreview/:id',
    name: 'HomeVisitReview',
    component: HomeVisitReview,
    beforeEnter: authGuard,
    props: true
  },
  {
    path: '/allhomevisitreview',
    name: 'AllHomeVisitReview',
    component: AllHomeVisitReview,
    beforeEnter: authGuard,
  },
  {
    path: '/newanalysis/:id/:source/:linked/:homevisitid/:autosave?',
    name: 'NewAnalysis',
    component: NewAnalysis,
    beforeEnter: authGuard,
    props: true
  },
  {
    path: '/newhomevisit/:aid',
    name: 'NewHomeVisit',
    component: NewHomeVisit,
    beforeEnter: authGuard,
    props: true
  },  
  {
    path: '/Pay/:id/:amount/:otype',
    name: 'Pay',
    component: Pay,
    beforeEnter: authGuard,
    props: true
  },   
  {
    path: '/PaySuccess/:id/:otype',
    name: 'PaySuccess',
    component: PaySuccess,
    beforeEnter: authGuard,
    props: true
  },     
  // {
  //   path: '/Companies/:approved',
  //   name: 'Companies',
  //   component: Companies,
  //   beforeEnter: authGuard,
  //   props: true
  // },  
  // {
  //   path: '/PaymentTypes',
  //   name: 'PaymentTypes',
  //   component: PaymentTypes,
  //   beforeEnter: authGuard,
  // },
  // {
  //   path: '/Documents',
  //   name: 'Documents',
  //   component: Documents,
  //   beforeEnter: authGuard,
  // },  
  {
    path: '/setpassword/',
    name: 'SetPassword',
    component: SetPassword,
    props: true
  }   
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// debugger;
export default router
